module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAAhklEQVQokWP8DwQMZAImGOP3n78EFaOrYYIJzl66i+Hxszc4NYLkQGpQDPgPBY+evv4/dcE2MI0OcMkxEFKEz1AGdAFkxfg0ggAjttAG+W/z7tNgtq+rKYOslAj+0CYLUOJs6gQY2VH16/cfvM5DNgCkFgbgoQ1KOawszHjDB10N1qgiFgAALli84sA8MukAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/fstb1-3.png
// module id = 838
// module chunks = 0